import firebase from "firebase";
import "firebase/app";
import "firebase/auth";
import "firebase/firestore"
import "firebase/analytics";

const firebaseConfig = {
    apiKey: "AIzaSyCuGWigoIpUEzAXoR-4FduFZPypdPeR1nA",
    authDomain: "fincalo.firebaseapp.com",
    projectId: "fincalo",
    storageBucket: "fincalo.appspot.com",
    messagingSenderId: "302193544721",
    appId: "1:302193544721:web:aa963cc02805f4652c6bb0",
    measurementId: "G-BYH7HL8BCD"
  };
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);
  firebase.analytics();


  export default firebase;